import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import CaseListItem from '../CaseListItem/CaseListItem';

import './CaseList.scss';

const CaseList = ({ data }) => (
  <div className="case-list">
    {data.map(({
      caseNumber,
      court,
      filingDate,
      id,
      name,
    }) => (
      <div
        className="case-list__item-wrapper"
        key={id}
      >
        <RouterLink to={`/cases/${id}`}>
          <div className="case-list__item">
            <CaseListItem
              name={name}
              caseNumber={caseNumber}
              court={court}
              filingDate={filingDate}
            />
          </div>
        </RouterLink>
      </div>
    ))}
    {!data.length && (
      <div className="case-list__error">
        There are no cases to display.
      </div>
    )}
  </div>
);

CaseList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    caseNumber: PropTypes.string,
    court: PropTypes.string,
    filingDate: PropTypes.string,
  })),
};

CaseList.defaultProps = {
  data: [],
};

export default CaseList;



// WEBPACK FOOTER //
// ./src/routes/Cases/components/CaseList/CaseList.js